module.exports = __webpack_public_path__ + "img/main.44cfce04.png";